import React from 'react';
import { Building2, MapPin, Star } from 'lucide-react';
import { motion } from 'framer-motion';

const SuccessStories = () => {
  const successStories = [
    {
      name: "Trupti Nagar",
      photo: require("../assets/success stories/TruptiNagar_Microsoft.png"),
      company: "Microsoft",
      location: "USA",
      package: "₹12L+",
      role: "Software Engineer"
    },
    {
      name: "Sachin Tomar",
      photo: require("../assets/success stories/SachinTomar_CityBank.png"),
      company: "City Bank",
      location: "Pune",
      package: "₹8L+",
      role: "Full Stack Developer"
    },
    {
      name: "Shubham Jain",
      photo: require("../assets/success stories/ShubhamJain_NTT Data.png"),
      company: "NTT Data",
      location: "USA",
      package: "₹15L+",
      role: "Data Engineer"
    },
    {
      name: "Neeraj Sharma",
      photo: require("../assets/success stories/NeerajSharma_HCL.png"),
      company: "HCL",
      location: "Netherlands",
      package: "₹10L+",
      role: "Backend Developer"
    },
    {
      name: "Rakshit Bhatia",
      photo: require("../assets/success stories/RakshitBhatia_JDSoftware.png"),
      company: "JD Software",
      location: "Bangalore",
      package: "₹9L+",
      role: "Frontend Developer"
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-6">
      {successStories.map((story, index) => (
        <motion.div 
          key={index} 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: index * 0.1 }}
          whileHover={{ y: -5, scale: 1.02 }}
          className="bg-white/90 dark:bg-gray-800/90 backdrop-blur-sm rounded-2xl overflow-hidden shadow-lg border border-gray-100 dark:border-gray-700 hover:shadow-2xl transition-all duration-300 group"
        >
          {/* Profile Photo Section */}
          <div className="relative bg-gradient-to-br from-green-100 to-emerald-100 dark:from-gray-700 dark:to-gray-600 h-80 sm:h-96 md:h-80 lg:h-96 xl:h-80 overflow-hidden">
            <img 
              src={story.photo} 
              alt={story.name} 
              className="w-full h-full object-cover object-center group-hover:scale-110 transition-transform duration-500"
              onError={(e) => {
                e.target.style.display = 'none';
                e.target.nextSibling.style.display = 'flex';
              }}
            />
            {/* Fallback for broken images */}
            <div className="hidden w-full h-80 sm:h-96 md:h-80 lg:h-96 xl:h-80 bg-gradient-to-br from-green-200 to-emerald-200 dark:from-gray-600 dark:to-gray-500 flex items-center justify-center">
              <div className="text-gray-600 dark:text-gray-300 text-center">
                <div className="w-16 h-16 bg-gradient-to-br from-green-400 to-emerald-400 rounded-full flex items-center justify-center mx-auto mb-2">
                  <span className="text-xl font-bold text-white">
                    {story.name.split(' ').map(n => n[0]).join('')}
                  </span>
                </div>
                <span className="text-sm font-medium">{story.name}</span>
              </div>
            </div>
          </div>
          
          {/* Information Section */}
          <div className="p-5 bg-white dark:bg-gray-800">
            <h4 className="font-bold text-gray-900 dark:text-white text-lg mb-2 truncate group-hover:text-green-600 dark:group-hover:text-green-400 transition-colors duration-300">
              {story.name}
            </h4>
            
            <div className="space-y-2">
              <div className="flex items-center text-green-600 dark:text-green-400 text-sm font-semibold">
                <Building2 className="w-4 h-4 mr-2 flex-shrink-0" />
                <span className="truncate">{story.company}</span>
              </div>
              <div className="flex items-center text-blue-600 dark:text-blue-400 text-sm font-medium">
                <MapPin className="w-4 h-4 mr-2 flex-shrink-0" />
                <span className="truncate">{story.location}</span>
              </div>
            </div>
          </div>
        </motion.div>
      ))}
    </div>
  );
};

export default SuccessStories; 